import {
  Box,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import { Trans } from '@gamiphy/react-i18n';
import { OtpForm } from '@gamiphy/loyalty/loyaltyPage/components/cashbackProgram/verification/otp';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { PhoneVerifyRequestTypeEnum } from '@coretava/api/core-service';

const Otp: React.FC<{
  phone: string,
  name?: string,
  onEditPhone: () => void,
  onDone: () => void
}> = ({
  phone,
  name,
  onEditPhone,
  onDone,
}) => {
  const handleVerification = React.useCallback(async (newPhone: string, otp: string) => {
    if (UserStore.isLoggedIn) {
      await UserStore.verifyPhone(newPhone, otp);
    } else {
      await UserStore.createAndVerifyUser({
        otp, name, contact: phone, type: PhoneVerifyRequestTypeEnum.Phone,
      });
    }
  }, [UserStore.isLoggedIn]);

  const handleOtpResend = React.useCallback(async () => {
    if (UserStore.isLoggedIn) {
      await UserStore.api.usersVerificationsControllerResendOtp(AppStore.app.id, { phone });
    } else {
      await UserStore.api.usersVerificationsControllerUpdatePhone(AppStore.app.id, { phone });
    }
  }, [
    UserStore.api,
    UserStore.isLoggedIn,
  ]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography fontSize="2rem" fontWeight={600}>
        <Trans
          i18nKey="coreloyalty.cashback.pin.enter"
          defaults="Enter PIN code"
        />
      </Typography>
      <Typography fontSize="1.6rem" fontWeight={400} color="#4F4F4F">
        <Trans
          i18nKey="cashbackPopup.code.sent"
          defaults="We've sent you a 6-digit code via SMS to your number {{phoneNumber}}"
          values={{
            phoneNumber: phone,
          }}
        />
      </Typography>
      <OtpForm
        buttonsDirection="column"
        height={46}
        fontSize={18}
        fullWidthButtons
        phone={phone}
        onDone={onDone}
        verifyPhone={handleVerification}
        fetchDiscounts={async () => { await DiscountsStore.getDiscounts(); }}
        resendOtp={handleOtpResend}
        onEditPhone={onEditPhone}
      />
    </Box>
  );
};

export default observer(Otp);
